export default "__VITE_ASSET__DsprSyua__"